import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';

import plus from '../../../../images/plus-grey.svg';
import plusActive from '../../../../images/plus-orange.svg';
import minusActive from '../../../../images/minus-orange.svg';
//
import blackChevron from '../../../../images/black-chevron-right.svg';

export const AccordionWrapper = styled(Accordion)`
  &.curriculum {
    border: 1px solid #979797;
    margin: 0 -20px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    &.curriculum {
      margin: 0;
    }
  }
`;

export const StyledAccordion = styled(AccordionItem)`
  border-bottom: 1px solid #979797;
  /* padding: 15px 0; */

  &:first-child {
    border-top: 1px solid #979797;
  }

  &.curriculum {
    padding: 0;

    &:last-child {
      border-bottom: none;
    }

    &.strand {
      background-color: #f8f8f6;
    }

    &.expectation {
      background-color: #f0efec;
    }

    &.skill {
      background-color: #f0efec;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    /* padding: 25px 0; */

    &.curriculum {
      /* padding: 15px 0; */
    }
  }
`;

export const AccordionHeader = styled(AccordionItemHeading)`
  font-size: 20px;
  font-family: ${themeGet('fonts.primary')};
  font-weight: ${themeGet('font-weights.bold')};
  letter-spacing: -0.38px;
  line-height: 28px;

  ${StyledAccordion}.curriculum & {
    font-weight: normal;
    font-size: 16px;
    letter-spacing: 0.2px;
    line-height: 28px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    font-size: 26px;
    letter-spacing: -0.5px;
    line-height: 38px;
  }
`;

export const AccordionBtn = styled(AccordionItemButton)`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  transition: background-color 300ms;

  /* change */
  padding: 15px 0;

  &::after {
    content: '';
    min-height: 19px;
    min-width: 19px;
    background-image: url(${plus});
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    margin-left: 15px;
  }

  /* When hovered */
  &:hover,
  &:focus {
    background-color: ${themeGet('colors.cream')};
    &::after {
      background-image: url(${plusActive});
    }
  }

  /* When open */
  &[aria-expanded='true'],
  &[aria-selected='true'] {
    &::after {
      background-image: url(${minusActive});
    }
  }

  ${StyledAccordion}.curriculum & {
    padding: 15px 15px;
    flex-direction: row-reverse;
    justify-content: flex-end;

    align-items: flex-start;

    &::after {
      content: '';
      min-height: 10px;
      min-width: 14px;
      background-image: url(${blackChevron});
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      /* transform: rotate(90deg); */
      margin-right: 15px;
      margin-left: 0;
      margin-top: 9px;
    }

    /* When hovered */
    &:hover,
    &:focus {
      background-color: ${themeGet('colors.white')};
      &::after {
        background-image: url(${blackChevron});
      }
    }

    /* When open */
    &[aria-expanded='true'],
    &[aria-selected='true'] {
      &::after {
        transform: rotate(90deg);
      }
    }
  }

  ${StyledAccordion}.curriculum.expectation & {
    padding: 15px 29px;
  }

  ${StyledAccordion}.curriculum.skill & {
    padding: 15px 43px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    /* chamge */
    padding: 25px 0;

    padding-right: 30px;

    padding: 25px 30px 25px 20px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    ${StyledAccordion}.curriculum & {
      padding: 15px 30px;

      &::after {
        min-height: 14px;
        min-width: 18px;
        margin-right: 20px;
        margin-left: 0;
        margin-top: 8px;
      }
    }

    ${StyledAccordion}.curriculum.expectation & {
      padding: 15px 64px;
    }

    ${StyledAccordion}.curriculum.skill & {
      padding: 15px 102px;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xl')}) {
  }
`;

export const AccordionBody = styled(AccordionItemPanel)`
  padding: 5px 0 20px;

  ${StyledAccordion}.curriculum & {
    padding: 0;
  }

  ${StyledAccordion}.curriculum.skill & {
    padding: 10px 72px;
    padding: 10px 20px;
  }

  p + p {
    margin-top: 15px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    padding: 5px 30px 40px 20px;

    p + p {
      margin-top: 25px;
    }

    ${StyledAccordion}.curriculum.skill & {
      padding: 10px 140px;
    }
  }
`;
